import { Wallet, Clock3, FolderSearch, RotateCcw, EyeOff } from "lucide-react";
import { Container, Eyebrow, H2, Reveal, PrimaryCta } from "./ui";

const WORDS = ["Funcionários.", "Treinamentos.", "Sistemas.", "Retrabalho.", "Prazos.", "Férias.", "Rescisões.", "Encargos.", "eSocial.", "Documentos.", "Cobranças internas.", "Informações espalhadas."];
const PAINS = [
  [Wallet, "Custo fixo alto", "Manter uma estrutura interna de Departamento Pessoal pode representar um custo significativo todos os meses."],
  [Clock3, "Prazos e obrigações", "Uma rotina de DP envolve dezenas de processos, informações e prazos."],
  [FolderSearch, "Informações espalhadas", "E-mails, planilhas, WhatsApp e documentos dificultam o controle e a rastreabilidade."],
  [RotateCcw, "Retrabalho", "Informações incompletas e processos manuais aumentam o retrabalho."],
  [EyeOff, "Falta de visibilidade", "Muitas empresas enviam informações para o DP e depois não sabem exatamente o que está acontecendo."],
];

export function Pain() {
  return (
    <section className="bg-[#F8FAFC] py-20 sm:py-28" data-testid="lp-pain">
      <Container className="grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow>O custo invisível</Eyebrow>
          <H2>Quanto custa manter seu DP do jeito que está?</H2>
          <p className="mt-8 flex flex-wrap gap-x-2.5 gap-y-1 font-display text-xl sm:text-2xl font-medium text-slate-400 leading-snug">{WORDS.map((w, i) => <span key={w} className={i % 3 === 2 ? "text-[#063C6D]" : ""}>{w}</span>)}</p>
          <p className="mt-8 text-lg text-slate-700 font-medium">Tudo isso consome dinheiro e tempo da sua empresa.</p>
        </Reveal>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {PAINS.map(([Icon, t, d], i) => (
            <Reveal key={t} delay={i * 70} className={`rounded-2xl border border-slate-200 bg-white p-6 transition-[border-color,box-shadow] duration-200 hover:border-[#0B6FC2]/40 hover:shadow-lg hover:shadow-slate-200/60 ${i === 4 ? "sm:col-span-2" : ""}`}>
              <Icon className="h-5 w-5 text-[#0B6FC2]" />
              <h3 className="mt-4 font-display text-lg font-semibold text-[#0F172A] uppercase tracking-wide">{t}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{d}</p>
            </Reveal>))}
        </div>
      </Container>
    </section>);
}

export function Solution() {
  return (
    <section className="relative overflow-hidden bg-[#063C6D] py-20 sm:py-28 text-white" data-testid="lp-solution">
      <div className="pointer-events-none absolute inset-0 lp-grid-dark" />
      <Container className="relative max-w-5xl">
        <Reveal>
          <Eyebrow light>A virada</Eyebrow>
          <H2 light className="lg:text-6xl">E se o seu Departamento Pessoal funcionasse como um serviço digital?</H2>
          <div className="mt-10 grid md:grid-cols-2 gap-10 items-end">
            <div className="space-y-5 text-lg leading-relaxed text-sky-50/85">
              <p>Com a DPdigi, sua empresa envia as movimentações pelo portal, acompanha o processamento e recebe as respostas e documentos no mesmo ambiente.</p>
              <p className="text-white font-medium">Sem perder o histórico.<br />Sem depender de informações espalhadas.<br />Com muito mais controle sobre cada solicitação.</p>
            </div>
            <div className="md:text-right">
              <p className="font-display text-2xl text-sky-200 mb-6">Você envia. A DPdigi processa. Você acompanha.</p>
              <PrimaryCta source="solution" testid="lp-solution-cta" light />
            </div>
          </div>
        </Reveal>
      </Container>
    </section>);
}
